module.exports = __webpack_public_path__ + "img/9791160071221.ab321bbe.jpg";